import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GenericDialogComponent } from '../components/generic-dialog/generic-dialog.component';
import { AbstractControl, ValidationErrors } from '@angular/forms';

interface genericDialogConfigInterface {
  image?: string;
  imageAlt?: string;
  title?: string;
  app?: string;
  subTitle?: string;
  submitLabel?: string;
  fields?: {
    type?: string;
    label?: string;
    inputSize?: string;
    name?: string;
    multiple?: boolean;
    options?: {
      value?: string | number | boolean | unknown;
      label?: string;
    }[];
    validators?: ((control: AbstractControl) => ValidationErrors | null)[];
    value?: string | number | boolean | unknown;
    link?: string;
    qrUrl?: string;
    mask?: string;
  }[];
  autoClose?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  openPopup(config: genericDialogConfigInterface): MatDialogRef<GenericDialogComponent> {
    this.dialog.closeAll();

    return this.dialog.open(GenericDialogComponent, {
      data: { ...config, autoClose: config.autoClose ?? true },
      panelClass: ['wm-dialog'],
      backdropClass: 'wm-dialog-backdrop',
      autoFocus: false,
      restoreFocus: false,
    });
  }
}
